import { Helmet } from 'react-helmet-async';
import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Slider from '../Elements/Slider';
import AboutSection from '../Elements/AboutSection';
import ProductsSection from '../Elements/ProductsSection';
import Projects from '../Elements/Projects';
import Testimonials from '../Elements/Testimonials';
import '../../styles/pages/Home.css';


class Home extends React.Component {
    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }
        loadScript('/assets/js/custom.js');
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>bs clads</title>
                    <meta name="description" content="bs clads is a premier specialist in architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions since 2010." />
                </Helmet>
                <Header />
                <div className="page-content">
                    <Slider />
                    <AboutSection />
                    <ProductsSection />
                    <Projects />
                    <Testimonials />
                </div>
                <Footer />
            </>
        );
    }
}

export default Home;
